import React from 'react'
import SVG from 'react-inlinesvg'

export const CmsIcon = ({ name, size = 24, style = {} }) => {
  const nameWithPath = `${window.location.protocol}//${window.location.host}/static/images/icons-pickle/${name}.svg`
  return <SVG src={nameWithPath} style={{ width: `${size}px`, height: `${size}px`, ...style }} />
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/CmsIcon/CmsIcon.jsx